export default __webpack_public_path__ + "assets/fonts/DMSans-Regular-3640.ttf";